import React from 'react';
import styles from './style.css';

const RDFTermsLegal = () => {
  return (
    <div className="legal-container">
      <div className="legal">
        <p>
          The principal value of the target date funds is not guaranteed at any
          time, including at or after the target date; the funds are not
          designed for a lump-sum redemption at the target date and do not
          guarantee a particular level of income.
        </p>
        <p>
          The T. Rowe Price Retirement Fund Recommendation Service is a
          non-discretionary advisory service provided by T. Rowe Price Advisory
          Services, Inc., a registered investment adviser under the Investment
          Advisers Act of 1940. T. Rowe Price Advisory Services, Inc., and T.
          Rowe Price Investment Services, Inc., are affiliated companies.
        </p>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RDFTermsLegal;
